module.exports = __webpack_public_path__ + "media/images/zaap-27eaae4b8b853764ce93a7c5d115dac1.png";